import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import apiUrl from '../../Config';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    CircularProgress,
    Box,
    Avatar, Button,
    Tooltip,
    IconButton,
    Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Pencil, Plus, Trash, Trash2 } from 'lucide-react';
import { toast } from 'react-toastify';
import Context from '../../context/Context';
import DeleteConfirm from '../../Common/DeleteConfirm';

const DisplayOffers = () => {
    const { isConfirmDeleteModelOpen, setIsConfirmDeleteModelOpen, itemIdToDelete,
        confirmDelete } = useContext(Context);
    const navigate = useNavigate();
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getAllOffers = async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + `/offers/getalloffers`);
            if (response?.data?.status === true) {
                setOffers(response.data.offers);

            }
        } catch (error) {
            setError('Error fetching offers:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (offerDetails) => {
        navigate('/create-edit-offers', { state: offerDetails })
    }

    const handleDelete = async () => {
        setIsConfirmDeleteModelOpen(false)
        setLoading(true)
        try {
            const response = await axios.delete(apiUrl + `/offers/offers/${itemIdToDelete}`)
            if (response?.data?.status === true) {
                toast.success(response?.data?.message || " Offer deleted successfully");
                getAllOffers()
            }

        } catch (error) {
            setError(error)
        }
        finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAllOffers();
    }, []);

    return (
        <>
            <Box p={4}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',mb:2 }}>
                    <Typography variant="h5" gutterBottom>
                        All Offers
                    </Typography>
                    <Button color="primary" variant='contained' onClick={() => navigate('/create-edit-offers')}
                        sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}>
                        <Plus size={23} />
                        <Typography> Create Offer</Typography>

                    </Button>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <Box>

                    {loading ? (
                        <Box display="flex" justifyContent="center" mt={4}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box >
                            <TableContainer
                                component={Paper}
                                sx={{
                                    width: '100%',
                                    maxWidth: '100vw',
                                    overflowX: 'auto',
                                    boxShadow: 2,
                                }}
                            >
                                <Table sx={{ minWidth: 900 }} aria-label="offers table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: 100 }}><strong>Image</strong></TableCell>
                                            <TableCell sx={{ width: 180 }}><strong>Title</strong></TableCell>
                                            <TableCell sx={{ width: 250 }}><strong>Description</strong></TableCell>
                                            <TableCell sx={{ width: 120 }}><strong>Coupon Code</strong></TableCell>
                                            <TableCell sx={{ width: 120 }}><strong>Discount</strong></TableCell>
                                            <TableCell sx={{ width: 120 }}><strong>Min Amount</strong></TableCell>
                                            <TableCell sx={{ width: 140 }}><strong>Max Discount</strong></TableCell>
                                            <TableCell sx={{ width: 130 }}><strong>Valid From</strong></TableCell>
                                            <TableCell sx={{ width: 130 }}><strong>Valid To</strong></TableCell>
                                            <TableCell sx={{ width: 80 }}><strong>Active</strong></TableCell>
                                            <TableCell sx={{ width: 100 }} ><strong>Actions</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {offers.map((offer) => (
                                            <TableRow key={offer.id}>
                                                <TableCell>
                                                    <Avatar
                                                        src={offer.discountImage}
                                                        alt="discount"
                                                        variant="rounded"
                                                        sx={{ width: 48, height: 48 }}
                                                    />
                                                </TableCell>
                                                <TableCell>{offer.title}</TableCell>
                                                <TableCell>{offer.description}</TableCell>
                                                <TableCell>{offer.couponCode}</TableCell>
                                                <TableCell>
                                                    {offer.discountType === 'percentage'
                                                        ? `${offer.discountValue}%`
                                                        : `₹${offer.discountValue}`}
                                                </TableCell>
                                                <TableCell>₹{offer.minAmount}</TableCell>
                                                <TableCell>₹{offer.maxDiscountAmount}</TableCell>
                                                <TableCell>{new Date(offer.validFrom).toLocaleDateString()}</TableCell>
                                                <TableCell>{new Date(offer.validTo).toLocaleDateString()}</TableCell>

                                                <TableCell>{offer.isActive ? 'Yes' : 'No'}</TableCell>
                                                <TableCell >

                                                    <Box sx={{ display: 'flex', gap: 1.2 }}>
                                                        <IconButton size="small" onClick={(e) => handleEdit(offer)}>
                                                            <EditIcon width={18} />
                                                        </IconButton>
                                                        <IconButton size="small" color='error' onClick={(e) => confirmDelete(offer.id)}>
                                                            <DeleteIcon width={18} />
                                                        </IconButton>
                                                    </Box>

                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    )}
                    {error &&
                        <Typography variant='body2' color='error'>{error}</Typography>}
                </Box>
            </Box>
            <DeleteConfirm open={isConfirmDeleteModelOpen} onClose={() => setIsConfirmDeleteModelOpen(false)} onConfirm={handleDelete} />
        </>
    );
};

export default DisplayOffers;
